import { RoomLayout } from 'store/resource/types';
import { createAction } from 'typesafe-actions';

export const setRoomLayout = createAction('SET_ROOM_LAYOUT')<RoomLayout>();

export const resetRoomLayout = createAction('RESET_ROOM_LAYOUT')<undefined>();
